export default __webpack_public_path__ + "05d65838eead78a1f2c4a45c38798596.svg";